import { InjectionToken } from "@angular/core";

export const PRODUCT_VERSIONS_STATE_PROP = new InjectionToken<string>("PRODUCT_VERSIONS_STATE_PROP");
export const productVersionsStatePropProvider = {
    provide: PRODUCT_VERSIONS_STATE_PROP,
    useValue: "productVersions",
};

export const ORIGINAL_FEATURE_VERSIONS_STATE_PROP = new InjectionToken<string>("ORIGINAL_FEATURE_VERSIONS_STATE_PROP");
export const originalVersionsStatePropProvider = {
    provide: ORIGINAL_FEATURE_VERSIONS_STATE_PROP,
    useValue: "originalFeatureProductVersions",
};

export const FEATURE_VERSIONS_STATE_PROP = new InjectionToken<string>("FEATURE_VERSIONS_STATE_PROP");
export const featureVersionsStatePropProvider = {
    provide: FEATURE_VERSIONS_STATE_PROP,
    useValue: "featureProductVersions",
};

export const FEATURE_VERSIONS_ATTACHMENTS_STATE_PROP = new InjectionToken<string>("FEATURE_VERSIONS_ATTACHMENTS_STATE_PROP");
export const featureVersionsAttachmentsStatePropProvider = {
    provide: FEATURE_VERSIONS_ATTACHMENTS_STATE_PROP,
    useValue: "featureProductVersionsAttachments",
};

export const EPISODES_VERSIONS_STATE_PROP = new InjectionToken<string>("EPISODES_VERSIONS_STATE_PROP");
export const episodeVersionsStatePropProvider = {
    provide: EPISODES_VERSIONS_STATE_PROP,
    useValue: "episodeProductVersions",
};

export const PRODUCT_METADATA_STATE_PROP = new InjectionToken<string>("PRODUCT_METADATA_STATE_PROP");
export const productMetadataStatePropProvider = {
    provide: PRODUCT_METADATA_STATE_PROP,
    useValue: "productMetadata",
};

export const EPISODES_STATE_PROP = new InjectionToken<string>("EPISODES_STATE_PROP");
export const episodesStatePropProvider = {
    provide: EPISODES_STATE_PROP,
    useValue: "episodes",
};

export const CAST_CREDITS_STATE_PROP = new InjectionToken<string>("CAST_CREDITS_STATE_PROP");
export const castCreditsStatePropProvider = {
    provide: CAST_CREDITS_STATE_PROP,
    useValue: "castCredits",
};

export const CREW_CREDITS_STATE_PROP = new InjectionToken<string>("CREW_CREDITS_STATE_PROP");
export const crewCreditsStatePropProvider = {
    provide: CREW_CREDITS_STATE_PROP,
    useValue: "crewCredits",
};

export const PRODUCT_SYNOPSIS_STATE_PROP = new InjectionToken<string>("PRODUCT_SYNOPSIS_STATE_PROP");
export const productSynopsesStatePropProvider = {
    provide: PRODUCT_SYNOPSIS_STATE_PROP,
    useValue: "productSynopses",
};

export const SERIES_METADATA_STATE_PROP = new InjectionToken<string>("SERIES_METADATA_STATE_PROP");
export const seriesMetadataStatePropProvider = {
    provide: SERIES_METADATA_STATE_PROP,
    useValue: "seriesMetadata",
};

export const AMXT_VERSIONS_AVAILABLE_PROP = new InjectionToken<string>("AMXT_VERSIONS_AVAILABLE_PROP");
export const amxtVersionsAvailablePropProvider = {
    provide: AMXT_VERSIONS_AVAILABLE_PROP,
    useValue: "amxtVersionsAvailable",
};

export const EPISODE_SYNOPSES_STATE_PROP = new InjectionToken<string>("EPISODE_SYNOPSES_STATE_PROP");
export const episodeSynopsesPropProvider = {
    provide: EPISODE_SYNOPSES_STATE_PROP,
    useValue: "episodeSynopses",
};

export const FILES_STATE_PROP = new InjectionToken<string>("FILES_STATE_PROP");
export const filesPropProvider = {
    provide: FILES_STATE_PROP,
    useValue: "files",
};

export const PERMISSION_STATE_PROP = new InjectionToken<string>("PERMISSION_STATE_PROP");
export const permissionStatePropProvider = {
    provide: PERMISSION_STATE_PROP,
    useValue: "userPermission",
};
